import React from 'react';
import getConfig from 'next/config';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import serialize from 'serialize-javascript';

import getEnigmaConfig from 'lib/getEnigmaConfig';
import enigmaMapStoreToProps from 'lib/enigmaMapStoreToProps';

const mapStateToProps = (state) => ({ state });

function AdsBundle({ state }) {
  const { publicRuntimeConfig: { adsBundlePath } } = getConfig();
  const enigmaConfig = getEnigmaConfig(enigmaMapStoreToProps(state));

  return enigmaConfig
    ? (
      <>
        <script dangerouslySetInnerHTML={{ __html: `window.__enigmaconfig = ${serialize(enigmaConfig)};` }} />
        <script async src={adsBundlePath} />
      </>
    )
    : null;
}

AdsBundle.propTypes = {
  state: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default connect(mapStateToProps)(AdsBundle);
